module.exports = __webpack_public_path__ + "media/components/src/assets/images/cross/img-cross-8b6afba1b86e585ff7779f0fb91b89dd.svg";